import {getEnvironment} from "./../utils/environmantDetection";

let environment = getEnvironment();
let environmentWithoutDot = environment.replace('.', '');

let API_CONSTANTS = {
    ADD_TO_CART_URL: `https://api2.${environment}shutterfly.com/v1/web-cart-orch/cart/v1/carts/default/projects`,
    DEFAULT_ADD_TO_CART_QUANTITY: 1,
    CART_URL: `https://www.${environment}shutterfly.com/cart/`,
    CART_API_CONFIG: `djOlaaty605xAgYG2jOc9MwuwWtJ8NgG`,
    SPINNER_URL: `https://www.shutterfly.com/css/spinners/orange/2x/spinner-xl.png`,
    CGD_REPOSITORY_LINKS: {
        js: `/dist/js/cgd_product_renderer.js`,
        css: `/dist/css/cgd_product_renderer.css`
    },
    GET_CGD_REPOSITORY_UPDATES: `https://api2.shutterfly.com/frontendci/app/prevstatic/env/${environmentWithoutDot}/current-version`,
    LOCAL_CGD_REPOSITORY_LINK: 'https://cdn-beta.staticsfly.com/prevstatic/builds/cgdprev-20190826-1178-f911fb3e-7d877',
    SHARE_API_CONFIG: "cH872gj9Cg9yUnZmIJahLkCfdOdQiKJn",
    PROJECT_SERVICES_API_CONFIG: `cH872gj9Cg9yUnZmIJahLkCfdOdQiKJn`,
    PROJECT_SERVICES_URL: `https://api2.${environment}shutterfly.com/projects/v1/users/`,
    LIKE_COMMENT_BASE_URL: `https://api2.${environment}shutterfly.com/share/v1/`,
    API_STATUS_CODES: {
        NO_CONTENT: 204
    },
    SHARE_API_CALLER_ID: 'share-api',
    SHARE_WIDGET_VERSION: `https://api2.shutterfly.com/frontendci/app/share-widget/env/${environmentWithoutDot}/current-version?json`,
    TOTAL_LIKES_TO_SHOW: 10
};


//value will be null for production
if (environment === "") {
    API_CONSTANTS = {
        ADD_TO_CART_URL: `https://api2.shutterfly.com/v1/web-cart-orch/cart/v1/carts/default/projects`,
        DEFAULT_ADD_TO_CART_QUANTITY: 1,
        CART_URL: `https://www.shutterfly.com/cart/`,
        CART_API_CONFIG: `uWrM911sdIvHivflYxyiHlGgmlgoaV0m`,
        SPINNER_URL: `https://www.shutterfly.com/css/spinners/orange/2x/spinner-xl.png`,
        CGD_REPOSITORY_LINKS: {
            js: `/dist/js/cgd_product_renderer.js`,
            css: `/dist/css/cgd_product_renderer.css`
        },
        GET_CGD_REPOSITORY_UPDATES: `https://api2.shutterfly.com/frontendci/app/prevstatic/env/prod/current-version`,
        SHARE_API_CONFIG: "XPw3nKA2rPennPFGWYgnYxKAdfdTROH0",
        PROJECT_SERVICES_API_CONFIG: `XPw3nKA2rPennPFGWYgnYxKAdfdTROH0`,
        PROJECT_SERVICES_URL: `https://api2.shutterfly.com/projects/v1/users/`,
        LIKE_COMMENT_BASE_URL: 'https://api2.shutterfly.com/share/v1/',
        API_STATUS_CODES: {
            NO_CONTENT: 204
        },
        SHARE_API_CALLER_ID: 'share-api',
        SHARE_WIDGET_VERSION: 'https://api2.shutterfly.com/frontendci/app/share-widget/env/prod/current-version?json',
        TOTAL_LIKES_TO_SHOW: 10
    };
}

export default API_CONSTANTS;
